import React, { useState, useEffect, useRef } from "react";
import {useSelector,useDispatch} from "react-redux";
import {isEmpty} from "lodash";
import MetaTags from "react-meta-tags";
import { toast} from "react-toastify";
import moment from "moment/moment";
import "../Dashboard/index.css";
import BreadcrumbComponent from "../../components/BreadCrumb";
import dayjs from "dayjs"
import { Col, Row, Button, Modal,Typography, Input, DatePicker, Select, Image,  Space, Table, Form} from "antd";
import {
  CloudUploadOutlined,
  PlusCircleOutlined,
  EditOutlined,
  SearchOutlined,
  DownloadOutlined,
  DeleteOutlined,
  CloseCircleOutlined,
  PlusSquareTwoTone
} from "@ant-design/icons";
import TextArea from "antd/es/input/TextArea";
import SimpleReactValidator from "simple-react-validator";
import * as projectAction from "../../store/Project/action";
import * as employeeAction from '../../store/Employee/actions'
import api from "../../helpers";

const { Text } = Typography;


const ProjectMenu = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const specificDispatch = useDispatch();
  const [isEdit, setIsEdit] = useState(false);
  const dispatch = useDispatch();
  const [searchLoading, setSearchLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [projectId, setProjectId] = useState();
  const [searchValue, setSearchValue] = useState({
        limit: 10,
        page: 1,
      });
  // const [isConfirmVisible, setIsConfirmVisible] = useState(false);
  const [, forceUpdate] = useState({});
  const [fields, setFields] = useState([]);
  const [from] = Form.useForm();
  const [downloadLoader, setDownloadLoader] = useState(false);
  const [open, isOpen] = useState(false);
  const [isConfirmVisible, setIsConfirmVisible] = useState(false);
  const updatedDropdown = useSelector((ss)=>ss.Project);
  const {projectlist}=updatedDropdown
  const employeeDropdown = useSelector((ss)=>ss.Employee);
  const [employeeName, setemployeeName] = useState([]);
  const [disabled, setDisabled] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(projectlist?.total);
  const [totalCount,setTotalCount] = useState(projectlist.total);
    console.log(projectlist.total,"count")
    useEffect(() => {
        if (projectlist) {
          setTotalCount(projectlist?.total);
        }
      }, [projectlist]);

  console.log(employeeDropdown.employee_list?.data , 'employeeDropdown');
  console.log(updatedDropdown,"updateddropdownddd")
  console.log(updatedDropdown.projectlist,"updatedproject");

  console.log(updatedDropdown.dropdownlist,"projectstatusoptions")
  const {dropdownlist} = updatedDropdown

  
  const employeeOption = employeeDropdown.employee_list?.data  &&  employeeDropdown.employee_list?.data.length > 0 ?  employeeDropdown.employee_list?.data.map((data)=>{
    return{
      label :data.employeeName,
      value:  data._id,
    }
  }) : []

  console.log("empOpt",employeeOption);

  useEffect(()=>{
    specificDispatch(projectAction.loadProjectDetails({
      limit:10,
      page:1,
      status:"BOTH",
    }))
    specificDispatch(projectAction.loadDropdownProject());
    specificDispatch(employeeAction.loadEmployee());
  },[specificDispatch]);

    useEffect(()=>{
    specificDispatch(projectAction.loadDropdownProject({
      limit:10,
      page:1,
      status:"BOTH",
    }))
    specificDispatch(projectAction.loadDropdownProject());
  },[specificDispatch]);

  const simpleValidator = useRef(new SimpleReactValidator());

  const BCrumb = [
    { to: "/", title: "Home" },
    { title: "Projects" },
  ];

  const handleRemovePreview = (urlToRemove) => {
    setImagePreviews([]);
    setFileNames("");
    URL.revokeObjectURL(urlToRemove);
  };

  const handleModalClose = () => {
    setIsModalVisible(false);
  };

  const handleSearch = () => {
        const payload = {
          search: searchInput,
        };
        console.log(payload,"payloadsearch")
        setSearchLoading(true);
    
        setTimeout(() => {
          setSearchLoading(false);
        }, 500);
        setSearchValue(payload);
        dispatch(projectAction.loadProjectDetails(payload));
      };

  const clearModelData = () => {
    from.resetFields()
    setProjectDetails({
      projectCode: "",
      startDateDate: "",
      endDate: "",
      budget: "",
      projectstatus:"",
      attachment:[],
      description:"",
      teamDetails:[],
      externalLink:[],
    });
    setImagePreviews([]);
  };

  const showModalOpen = () => {
    setIsEdit(false);
    clearModelData();
    setIsModalVisible(true);
  };

  const handleDeleteModalCancel = () => {
      setDeleteModalOpen(false);
    };
  
  const selectRef = useRef(null);
  const handleIconClick = () => {
    isOpen(true)
  };

  const handleInitialSubmit = () => {
    if (simpleValidator.current.allValid()) {
      setIsConfirmVisible(true);
    } else {
      simpleValidator.current.showMessages();
      forceUpdate(1);
    }
  };

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return { width, height };
  }

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleAddField = () => {
    setFields([...fields, { label: "", value: "" }]);
  };

  const handleRemoveField = (index) => {
  const newFields = [...fields];
  newFields.splice(index, 1);
  setFields(newFields);
};

const handleModalChange = (e) => {
    const { name, value } = e.target;

    setProjectDetails((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  useEffect(() => {
  setProjectDetails((prev) => ({
    ...prev,
    teamDetails: employeeName,
  }));
}, [employeeName]);


const [projectDetails, setProjectDetails] = useState({
    projectCode: "",
    projectName:"",
    budget:"",
    startDate: "",
    endDate: "",
    projectstatus:"",
    attachment:[],
    description: "",
    teamDetails:[],
    externalLink:[],
  });


  const tableData =
      updatedDropdown.projectlist.projects
        ? updatedDropdown.projectlist.projects.map((data, index) => {
          const statusOption = updatedDropdown.dropdownlist.projectStatusOptions.find(
          (option) => option.value === data.projectstatus
        );
            return {
              _id: data._id,
              sno: index + 1,
              projectCode: data.projectCode,
              projectName: data.projectName,
              budget: data.budget,
              startDate: moment(data.startDate).format("DD/MM/YYYY") || "--",
              endDate: moment.utc(data.endDate).format("DD/MM/YYYY") || "--",
              projectstatus: statusOption?statusOption.label:"-",
              attachment: data.attachment || "",
              description: data.description || "",
              teamDetails:data.teamDetails,
              editData: data,
            };
          })
        : []

        
  const handleDateChange = (field, date) => {
    const updatedDetails = { ...projectDetails, [field]: date };
    setProjectDetails(updatedDetails)
  }

const handleSubmit = () => {
  setDisabled(true);
  setTimeout(() => {
    setDisabled(false);
  }, 4000);

  const payload = {
    ...(isEdit && { id: projectDetails._id }),
    projectCode: projectDetails.projectCode,
    projectName: projectDetails.projectName,
    budget: projectDetails.budget,
    startDate: projectDetails.startDate?.format("YYYY-MM-DD"),
    endDate: projectDetails.endDate?.format("YYYY-MM-DD"),
    projectstatus: projectDetails.projectstatus || "--",
    description: projectDetails.description,
    teamDetails: (employeeName || []).map((emp) => ({
      employeeId: emp.value,
    })),
    externalLink: (fields || []).map((f) => ({
      label: f.label,
      value: f.value,
    })),
    status: 1,
    ...(!isEmpty(imagePreviews) && { attachment: imagePreviews[0].url }),
  };

  console.log("Payload sent:", payload);

  const endpoint = isEdit
    ? "/auth/employee/updateproject"
    : "/auth/employee/addproject";

  api
    .post(endpoint, payload)
    .then((response) => {
      if (response.status === 200 || response.status === 201) {
        dispatch(projectAction.loadProjectDetails());
        toast.success(
          isEdit
            ? "Project updated successfully"
            : "Project added successfully"
        );
      } else {
        toast.warning(response?.data?.msg || "");
      }
      setIsModalVisible(false);
    })
    .catch((err) => {
      setIsModalVisible(false);
      const errorMsg =
        err?.response?.data?.message ||
        `An error occurred while ${
          isEdit ? "updating" : "adding"
        } the project`;
      toast.error(errorMsg, { containerId: "toast-1" });
    });
};



  const handleEdit = (EditSheet) => {
  const projectcopy = EditSheet.editData;
  console.log(projectcopy, "pc");

  setIsEdit(true);
  const employeesForSelect =
    projectcopy.teamDetails?.map(t => ({
      label: t.employeeId?.employeeName,
      value: t.employeeId?._id,
    })) || [];

    const externalLinks =
    projectcopy.externalLink?.map((link) => ({
      label: link.label || "",
      value: link.value || "",
    })) || [];

  setProjectDetails({
    _id: projectcopy._id,
    projectCode: projectcopy.projectCode,
    projectName: projectcopy.projectName,
    budget: projectcopy.budget,
    startDate: projectcopy.startDate ? dayjs(projectcopy.startDate) : null,
    endDate: projectcopy.endDate ? dayjs(projectcopy.endDate) : null,
    projectstatus: projectcopy.projectstatus,
    attachment: projectcopy.attachment || [],
    description: projectcopy.description,
    teamDetails: employeesForSelect.map(e => e.value),
    externalLink:externalLinks
  });
  setImagePreviews(
    (projectcopy.attachment || []).map(url => ({ url }))
  );
  setemployeeName(employeesForSelect);
  setIsModalVisible(true);
};



  const handleDelete = () => {
      setDisabled(true);
      setTimeout(() => {
        setDisabled(false);
      }, 4000);
      const payload = {
        id:projectId,
      };
      api
        .post(`/auth/employee/deleteproject`, payload)
        .then((response) => {
          if (response.status === 200 || response.status === 201) {
            dispatch(projectAction.loadProjectDetails());
            toast.success("project deleted successfully");
          } else {
            toast.warning(response?.data?.msg || "");
          }
          setDeleteModalOpen(false);
          return response.data;
        })
        .catch((err) => {
          const errorMsg =
       err?.response?.data?.error||err?.response?.data?.message ||
            "An error occurred while deleting the leave details";
          toast.error(errorMsg);
            setDeleteModalOpen(false);
          return Promise.reject(err);
        });
    };

    const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType });

    const a = document.createElement("a");
    a.download = fileName;
    a.href = window.URL.createObjectURL(blob);
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    });
    a.dispatchEvent(clickEvt);
    a.remove();
  };

    const exportToCsv = async () => {
          let searchFilter = {};
      
          if (projectDetails.startDate)
            searchFilter.startDate = moment(
              projectDetails.startDate
            ).format("DD-MM-YYYY");
          if (projectDetails.endDate)
            searchFilter.endDate = moment(projectDetails.endDate).format(
              "DD-MM-YYYY"
            );
          if (projectDetails.projectCode)
            searchFilter.projectCode = projectDetails.projectCode;
        setDownloadLoader(true);
        try {
          const res = await api.post("/auth/employee/getproject", searchFilter);
          const projects = res.data?.projects || [];
    
          const mappedData = projects.map((data, index) => ({
            _id: data._id,
            sno: index + 1,
            projectCode: data.projectCode || "--",
            projectName: data.projectName || "--",
            startDate: data.startDate
              ? moment(data.startDate).format("DD/MM/YYYY")
              : "--",
            endDate: data.endDate ? moment(data.endDate).format("DD/MM/YYYY") : "--",
            projectstatus: data.projectstatus,
            description: data.description || "--",
            teamDetails:data.teamDetails || "--",
            editData: data,
          }));
    
          const headers = [
            "s.no",
            "projectCode",
            "ProjectName",
            "Budget",
            "startDate",
            "endDate",
            "Projectstatus",
            "Description",
            "Attachment",
            "TeamDetails",
          ];
    
          const csvRows = mappedData.map((item) => [
          item.sno,
          item.projectCode,
          item.projectName,
          item.budget,
          item.startDate,
          item.endDate,
          item.projectstatus,
          `"${item.description}"`,
          item.teamDetails?.map(t => t.employeeId?.employeeName).join("; ") || "--",
          item.attachment || "--",
          ]);
    
          const csvContent = [
            headers.join(","),
            ...csvRows.map((row) => row.join(",")),
          ].join("\n");
    
          downloadFile({
            data: csvContent,
            fileName: "project-details.csv",
            fileType: "text/csv",
          });
        } catch (error) {
          if (error) {
            setDownloadLoader(false);
          }
        } finally {
          setDownloadLoader(false);
        }
      };

 const [fileNames, setFileNames] = useState("");
  const [imagePreviews, setImagePreviews] = useState([]);
  
 const handleSinglePhoto = async (e) => {
  const files = e.target.files;
  if (!files || files.length === 0) return;

  const file = files[0];
  const formData = new FormData();
  formData.append("profilePicture", file);
  try {
   const res = await api.post("/auth/employee/upload-image", formData);
   if (res?.status === 200 && res?.data?.file) {
     toast.success("Image uploaded successfully!", { containerId: "toast-1" });
     setProjectDetails((prev) => ({
       ...prev,
       attachment: [...prev.attachment, res.data.file],
     }));
     setImagePreviews((prev) => [...prev, { url: res.data.file, name: file.name }]);
   }
  } catch (err) {
     toast.error("Upload failed", { containerId: "toast-1" });
    }
  };



  const handleChange = (index, key, e) => {
    const newFields = [...fields];
    newFields[index][key] = e.target.value;
    setFields(newFields);
  };

  const handleLinkChange = (index, value) => {
  const updatedLinks = [...(projectDetails.externalLink || [])];
  updatedLinks[index] = value;
  setProjectDetails((prev) => ({ ...prev, externalLink: updatedLinks }));
};
  
  // const projectOptions = !isEmpty(dropdownlist.projectOptions)
  // ? dropdownlist.projectOptions.map((po) => ({
  //     label: po.employeeName,
  //     value: po.id,
  //   }))
  // : [];

  const columns = [
      {
        title: (
          <span style={{ whiteSpace: "nowrap" }} className="poppins-txt">
            S.No
          </span>
        ),
        dataIndex: "sno",
        width: 70,
        className: "poppins-txt-lg",
        sorter: (a, b) => a.sno - b.sno,
      },
      {
        title: <span className="poppins-txt">Action</span>,
        dataIndex: "action",
        width: 130,
        render: (_, record) => (
          <Space style={{ gap: "8px" }}>
            {/* Edit Button */}
            <Button
              style={{
                background: "#34c38f",
                border: "none",
                minWidth: 30,
                height: 30,
                padding: "2px 4px",
                fontSize: "0.75rem",
              }}
              onClick={() => {
                handleEdit(record);
                setProjectId(record._id);
              }}
            >
              <EditOutlined style={{ color: "#fff", fontSize: 14 }} />
            </Button>
  
            {/* Delete Button */}
            <Button
              style={{
                background: "#f46a6a",
                border: "none",
                minWidth: 30,
                height: 30,
                padding: "2px 4px",
                fontSize: "0.75rem",
              }}
              onClick={() => {
                setDeleteModalOpen(true);
                setProjectId(record._id);
              }}
            >
              <DeleteOutlined style={{ color: "#fff", fontSize: 14 }} />
            </Button>
          </Space>
        ),
      },
      {
        title: (
          <span style={{ whiteSpace: "nowrap" }} className="poppins-txt">
            Project Code
          </span>
        ),
        dataIndex: "projectCode",
        width: 160,
        className: "poppins-txt-lg",
        sorter: (a, b) => a.projectCode.localeCompare(b.projectCode),
      },
      {
        title: "Project Name",
        dataIndex: "projectName",
        className: "poppins-txt-lg",
        sorter: (a, b) => a.projectName.localeCompare(b.projectName),
      },
      {
        title: "Budget",
        dataIndex: "budget",
        className: "poppins-txt-lg",
        sorter: (a, b) => a.budget.localeCompare(b.budget),
      },
      {
        title: "start Date",
        dataIndex: "startDate",
        className: "poppins-txt-lg",
        sorter: (a, b) => new Date(a.startDate) - new Date(b.startDate),
      },
      {
        title: "end Date",
        dataIndex: "endDate",
        className: "poppins-txt-lg",
        sorter: (a, b) => new Date(a.endDate) - new Date(b.endDate),
      },
      {
        title: "Project Status",
        dataIndex: "projectstatus",
        className: "poppins-txt-lg",
        sorter: (a, b) => a.projectstatus.localeCompare(b.projectstatus),
      },
      {
        title: "Description",
        dataIndex: "description",
        className: "poppins-txt-lg",
        sorter: (a, b) => a.reason.localeCompare(b.reason),
      },
      {
        title: "Attachment",
        dataIndex: "attachment",
        className: "poppins-txt-lg",
        render: (text, record) => {
          // const hasAttachment = !!record.attachment;
          return record.attachment !== null && record.attachment ? (
            <a
              href={record.attachment}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "blue", textDecoration: "underline" }}
            >
              View
            </a>
          ) : (
            <span
              style={{
                color: "gray",
                textDecoration: "none",
                cursor: "not-allowed",
              }}
            >
              View
            </span>
          );
        },
      },
      {
      title: "Team Details",
      dataIndex: "teamDetails",
      className: "poppins-txt-lg",
      render: (teamDetails) => (
        <span>
          {teamDetails && teamDetails.length > 0
            ? teamDetails.map(emp => emp.employeeId?.employeeName).join(", ")
            : "--"}
        </span>
      ),
      },
      ];


  return (
    <React.Fragment>
      <div className="pl-5">
        <MetaTags>
          <title>Project Menu</title>
        </MetaTags>
      </div>

      <Row justify="space-between" className="mr-4">
        <Col>
          <BreadcrumbComponent title="Project Menu" items={BCrumb} />
        </Col>

        <Col>
          <Button
            className="custom-btn mt-2"
            type="primary"
            size="medium"
            onClick={showModalOpen}
          >
            Create Project
          </Button>
        </Col>
      </Row>

      <Modal
      open={isModalVisible}
      onCancel={handleModalClose}
      title={
      <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        fontSize: "20px",
      }}
      className="poppins-txt"
      >
      <span>{isEdit ? "Edit Project" : "Create Project"}</span>
    </div>
    }
    className="poppins-txt custom-active-modal"
    centered
    maskClosable={false}
    footer={true}
    width="75vw"
    height="590px"
    maxWidth="1200px"
    style={{
    padding: 0,
    marginLeft: windowDimensions.width > 992 ? "220px" : "0",
    }}
    >
      <div
      className="custom-modal-content"
      style={{
      height: "480px",
      overflowY: "auto",
      }}
      >
        <Row gutter={[16, 16]}>
        <Col xs={24} sm={24} md={12} lg={8} xl={8}>
        <div className="mb-2">
        <Typography className="poppins-txt"><Text style={{fontSize:16}}>Project Code</Text>
        <span style={{ color: "red", marginLeft: "2px" }}>*</span>
        </Typography>
        </div>
        <Input  
        type="text"
        placeholder="Enter Project Code" 
        name="projectCode" 
        value={projectDetails.projectCode}
        onChange={(e) =>
        setProjectDetails({ ...projectDetails, projectCode: e.target.value })
        }
        />
        </Col>

        <Col xs={24} sm={24} md={12} lg={8} xl={8}>
        <div className="mb-2">
        <Typography className="poppins-txt"><Text style={{fontSize:16}}>Project Name</Text>
        <span style={{ color: "red", marginLeft: "2px" }}>*</span>
        </Typography>
        </div>
        <Input 
        placeholder="Enter Project Name"
        name="projectName"
        value={projectDetails.projectName}
        onChange={(e)=>handleModalChange(e)}
        />
        </Col>

        <Col xs={24} sm={24} md={12} lg={8} xl={8}>
        <div className="mb-2">
        <Typography className="poppins-txt"><Text style={{fontSize:16}}>Budget</Text>
        <span style={{ color: "red", marginLeft: "2px" }}>*</span>
        </Typography>
        </div>
        <Input  
        placeholder="Enter the Budget"
        name="budget"
        value={projectDetails.budget}
        onChange={(e)=>handleModalChange(e)}
        />
        </Col>
   
        <Col xs={24} sm={24} md={12} lg={8} xl={8}>
        <div className="mb-2">
        <Typography className="poppins-txt"><Text style={{fontSize:16}}>Start Date</Text>
        <span style={{ color: "red", marginLeft: "2px" }}>*</span>
        </Typography>
        </div>
        <DatePicker className="custom-select py-2" value={projectDetails.startDate} name="fromDate"
         format="DD/MM/YYYY"
         onChange={(date)=>handleDateChange("startDate",date)}
         />
        </Col>

        <Col xs={24} sm={24} md={12} lg={8} xl={8}>
        <div className="mb-2">
        <Typography className="poppins-txt" ><Text style={{fontSize:16}}>End Date</Text>
        <span style={{ color: "red", marginLeft: "2px" }}>*</span>
        </Typography>
        </div>
        <DatePicker className="custom-select py-2" value={projectDetails.endDate} name="fromDate"
         format="DD/MM/YYYY"
         onChange={(date)=>handleDateChange("endDate",date)}
         />
        </Col>      

        <Col xs={24} sm={24} md={12} lg={8} xl={8}>
        <div className="mb-2">
        <Typography className="poppins-txt"><Text style={{fontSize:16}}>Project Status</Text>
        <span style={{ color: "red", marginLeft: "2px" }}>*</span>
        </Typography>
        </div>
        <Select
        placeholder="Select projectStatus"
        allowClear
        className="custom-select"
        value={projectDetails.projectstatus}
        onChange={(value) => setProjectDetails(prev => ({ ...prev, projectstatus: value }))}
        options={updatedDropdown.dropdownlist.projectStatusOptions}
        autoComplete="off"
        dropdownRender={(menu) => (
          <h1 className="option-text-font">{menu}</h1>
        )}
        />
        </Col>
        
        <Col xs={24} sm={24} md={12} lg={8} xl={8}>
        <div className="mb-2">
        <Typography className="poppins-txt"><Text style={{fontSize:16}}>Attachment file</Text>
        <span style={{ color: "red", marginLeft: "2px" }}>*</span>
        </Typography>
        </div>
        <div>
        <Input
        // value={}
        accept="image/*,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/plain"
        placeholder="Choose File"
        readOnly
        name="attachment"
        value={projectDetails.attachment.join(", ")}
        onClick={() =>
                    document.getElementById("gallery-file-upload").click()
                  }
        onChange={(e)=>handleModalChange(e)}
        // onClick={() =>}
        prefix={
          <CloudUploadOutlined
            style={{
              color: "green",
              fontSize: 24,
              marginRight: 12,
            }}
          />
        }
        style={{
          cursor: "pointer",
          paddingLeft: 8,
        }}
        />

        <input
        id="gallery-file-upload"
        type="file"
        accept="image/*"
        onChange={handleSinglePhoto}
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          opacity: 0,
          width: "100%",
          height: "100%",
          cursor: "pointer",
        }}
        />
        </div>
           {imagePreviews.length > 0 && (
  <div style={{ marginTop: 16 }}>
    <Typography.Text type="secondary">Preview:</Typography.Text>
    <div style={{
      display: "grid",
      gridTemplateColumns: "repeat(auto-fill, minmax(100px, 1fr))",
      gap: 12,
      marginTop: 12,
    }}>
      {imagePreviews.map((img, idx) => (
        <div key={idx} style={{ position: "relative" }}>
          <Image
            src={img.url}
            alt={img.name}
            width={100}
            height={100}
            style={{ borderRadius: 8, objectFit: "cover" }}
          />
          <Button
            icon={<CloseCircleOutlined />}
            type="text"
            danger
            size="small"
            style={{ position: "absolute", top: -8, right: -8 }}
            onClick={() => handleRemovePreview(img.url)}
          />
        </div>
      ))}
    </div>
  </div>
)}

        </Col>

        <Col xs={24} sm={24} md={17} lg={15} xl={15}>
        <div className="mb-2">
        <Typography className="poppins-txt">Description
          <span style={{ color: "red", marginLeft: "2px" }}>*</span>
          </Typography>
        </div>
        <TextArea
          placeholder="Enter Reason"
          rows={3}
          name="description"
          value={projectDetails.description}
          onChange={(e)=>handleModalChange(e)}
        />
        <span
          style={{
            color: "#ef3022",
            fontSize: "11px",
            marginTop: "8px",
            fontFamily: "poppins",
            display: "block",
          }}
        >
        </span>
        </Col>


        <Col xs={24} sm={24} md={12} lg={8} xl={8}>
        <div className="mb-2 flex items-center space-x-2"  >
        <PlusSquareTwoTone style={{fontSize:29, color:"blue", cursor:"pointer"}} onClick={handleIconClick} />
        <Select
        mode="multiple"
        ref={selectRef}
        placeholder="Add Team Members"
        allowClear
        open={open}
        onDropdownVisibleChange={(visible) => isOpen(visible)}
        className="custom-select"
        name="teamDetails"
        // value={employeeName?.value}
        value={employeeName.map(emp => emp.value)}
  onChange={(values, selectedOptions) => {
    setemployeeName(selectedOptions || []);
  }}

        // onChange={(value, options)=>{
        //   if(options){
        //     setemployeeName({
        //       label:options.label,
        //       value:value,
        //     })
        //   }else{
        //     setemployeeName([])
        //   }
        // }}
        autoComplete="off"
        options={employeeOption}
        dropdownRender={(menu) => (
          <h1 className="option-text-font">{menu}</h1>
        )}
        />
        </div>
        </Col>
        
        <Col xs={24} sm={24} md={12} lg={8} xl={8}>
        <div >
          <div className="flex items-center space-x-2">
          <Typography className="poppins-txt" style={{ fontSize:16,  display: "block"}}>External Link</Typography>
          <span style={{ color: "red", marginLeft: "2px" }}>*</span>
          <Button
          type="dashed"
          shape="circle"
          icon={<PlusCircleOutlined />}
          onClick={handleAddField}
          style={{ marginBottom: "12px" }}
          />
          {projectDetails.externalLink?.map((link, index) => (
    <div key={index} className="flex items-center space-x-2">
      <Input
        placeholder="Enter external link"
        value={link}
        onChange={(e) => handleLinkChange(index, e.target.value)}
        style={{ width: "100%" }}
      />
      <Button
        type="text"
        danger
        onClick={() => handleRemoveField(index)}
      >
        Remove
      </Button>
    </div>
  ))}
          </div>
          {fields.map((field, index) => (
            <Row gutter={12} key={index} style={{ marginBottom: "8px" }}>
              <Col span={10}>
              <Input
              placeholder="Label"
              value={field.label}
              onChange={(e) => handleChange(index, "label", e)}
              />
              </Col>
              <Col span={10}>
              <Input
              placeholder="Value"
              value={field.value}
              onChange={(e) => handleChange(index, "value", e)}
              />
              </Col>
              <Col span={2}>
              <Button
              type="text"
              danger
              shape="circle"
              icon={<CloseCircleOutlined />}
              onClick={() => handleRemoveField(index)}
              />
              </Col>
              </Row>
            ))}
            </div>
            </Col>
            </Row>
            </div>

            <div
            className="custom-modal-footer"
            style={{
            borderTop: "1px solid #ccc",
            padding: "10px 16px",
            display: "flex",
            justifyContent: "flex-end",
            }}
            >
            <Button
            className="custom-btn"
            onClick={handleModalClose}
            style={{
            backgroundColor: "#f46a6a",
            color: "#fff",
            border: "none",
            marginRight: "10px",
            }}
            >
            Cancel
            </Button>
            <Button
            disabled={disabled}
            className="custom-btn"
            style={{
            backgroundColor: "#34c38f",
            color: "#fff",
            border: "none",
            }}
            // onClick={() => setIsConfirmVisible(true)}
            onClick={handleInitialSubmit}
            >
            {isEdit ? "Update" : "Submit"}
            </Button>
            </div>
            </Modal>

            <Modal
            open={isConfirmVisible}
            onCancel={() => setIsConfirmVisible(false)}
            title={"Confirmation"}
            className="poppins-txt custom-active-modal"
            centered
            maskClosable={false}
            width={450}
            footer={null}
            maxWidth="1200px"
            style={{
              padding: 0,
              marginLeft: windowDimensions.width > 992 ? "220px" : "0",
            }}
            >
            <div style={{ textAlign: "center" }}>
              <p className="poppins-txt" style={{ padding: "15px" }}>
                Are you sure Do you want to {isEdit ? "update" : "submit"} this
                request?
              </p>
    
              <div
                className="custom-modal-footer"
                style={{
                  borderTop: "1px solid #ccc",
                  padding: "10px 16px 0px 0px",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  className="custom-btn"
                  style={{
                    backgroundColor: "#f46a6a",
                    color: "#fff",
                    border: "none",
                    marginRight: "10px",
                  }}
                  onClick={() => setIsConfirmVisible(false)}
                >
                  Close
                </Button>
                <Button
                  disabled={disabled}
                  className="custom-btn"
                  onClick={() => {
                    handleSubmit();
                    setIsConfirmVisible(false);
                  }}
                  style={{
                    backgroundColor: "#34c38f",
                    color: "#fff",
                    border: "none",
                  }}
                >
                  Confirm
                </Button>
              </div>
              <div
                style={{
                  marginTop: "20px",
                  display: "flex",
                  justifyContent: "center",
                }}
              ></div>
            </div>
            </Modal>


            <Modal
            title={"Confirmation"}
            open={deleteModalOpen}
            onCancel={handleDeleteModalCancel}
            cancelText="Cancel"
            className="poppins-txt custom-active-modal"
            width={450}
            footer={null}
            // style={{ padding: 0 }}
            centered
            >
            <div className="custom-modal-content">
              <p>Are you sure you want to delete this project?</p>
            </div>
    
            <div
              className="custom-modal-footer"
              style={{
                borderTop: "1px solid #ccc",
                padding: "10px 16px",
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Button
                className="custom-btn"
                style={{
                  backgroundColor: "#f46a6a",
                  color: "#fff",
                  border: "none",
                  marginRight: "10px",
                }}
                onClick={() => handleDeleteModalCancel()}
              >
                Close
              </Button>
              <Button
                disabled={disabled}
                className="custom-btn"
                onClick={() => handleDelete()}
                style={{
                  backgroundColor: "#34c38f",
                  color: "#fff",
                  border: "none",
                }}
              >
                Confirm
              </Button>
            </div>
            </Modal>
            

            <div>
            <Row
                justify="space-between"
                align="middle"
                style={{ marginBottom: 16 }}
              >
                <Col>
                      <Input
                        placeholder="Search..."
                        allowClear
                        style={{ width: 250, fontFamily: "Poppins" }}
                        name="searchInput"
                        value={searchInput}
                        onChange={(e) => setSearchInput(e.target.value)}
                        type="text"
                        autoComplete="off"
                      />
                      <Button
                        icon={<SearchOutlined />}
                        type="primary"
                        style={{ marginLeft: 8 }}
                        onClick={handleSearch}
                      />
                </Col>
      
                <Col>
                  <Button
                    className="custom-btn"
                    size="medium"
                    type="primary"
                    icon={<DownloadOutlined />}
                    loading={downloadLoader}
                    onClick={exportToCsv}
                  >
                    Download
                  </Button>
                </Col>
              </Row>


            <Table
            columns={columns}
            loading={searchLoading}
            dataSource={tableData} 
            rowKey={(record) => record._id}
            rowClassName={"text-[12px]"}
            pagination={{
            current: currentPage,
            pageSize: pageSize,
            total: totalRecords,
            showSizeChanger: true,
            pageSizeOptions: ["5", "10", "20", "50"],
            showTotal: (total) => `Total ${total} projects`,
            }}
            sortDirections={["ascend", "descend"]}
            showSorterTooltip={"sorter-icon"}
            scroll={{ x: 765 }}
            onChange={(pagination, filters, sorter) => {
              const { current, pageSize } = pagination;
          
              setCurrentPage(current);
              setPageSize(pageSize);
              const updatedParams = {
                ...searchValue,
                page: current,
                limit: pageSize,
                status: "BOTH",
              };
              specificDispatch(projectAction.loadProjectDetails(updatedParams));
            }}
          />

            </div>
            </React.Fragment>
            )
          };

          
export default ProjectMenu;